import React, { Component } from "react";
import PageComponent from "./index";
import { connect } from "react-redux";

class CustomDataTutorialPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.onLoadHeaderColor("GREEN");
        this.props.onLoadHeaderTheme("DARK");
        this.props.onLoadShowLanguage("SHOW");

        const breadcrumb = [
            { name: "首頁", href: "/" },
            {
                name: "花東地區地震認知與避難行為調查",
                href: "/statistics/ChishangEarthquake",
            },
            {
                name: "客製化專區",
                href: "/statistics/ChishangEarthquake/custom-data",
            },
        ];
        this.props.onLoadShowBreadcrumb("SHOW", breadcrumb);
        this.props.onLoadShowLanguage("HIDE");

    }

    render() {
        return <PageComponent />;
    }
}

const mapStateToProps = (state) => ({
    color: state.header.color,
    theme: state.header.theme,
    showLanguage: state.header.showLanguage,
    showBreadcrumb: state.header.showBreadcrumb,
});

const mapDispatchToProps = (dispatch) => ({
    onLoadHeaderColor: (COLOR) => dispatch({ type: "HEADER_COLOR_" + COLOR }),
    onLoadHeaderTheme: (THEME) => dispatch({ type: "HEADER_THEME_" + THEME }),
    onLoadShowLanguage: (STATUS) => dispatch({ type: STATUS + "_LANGUAGE" }),
    onLoadShowBreadcrumb: (STATUS, data) =>
        dispatch({ type: STATUS + "_BREADCRUMB", breadcrumbData: data }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomDataTutorialPage);
